export const DATADOG_APPS_IDS = {
    'frontend-obs': '38c83a51-8977-493b-8e06-1357bef64227',
    'frontend-openbanking': '53b1f6a2-5c01-4cd4-9e86-e3b48d939b65',
    'frontend-raisin-bank-website': '4acdcdcc-25f2-4228-83d2-2cbda36fa64e',
    'frontend-cp-account-transactions': '547821aa-bc0d-4860-b02d-fb97e4aca53c',
    'frontend-cp-account-withdrawal': '4d4ab56b-c096-4d43-aa15-6af1088fe0eb',
    'frontend-cp-customer-data': '4549a9b3-e30b-46b6-8fc2-e75e3a88913e',
    'frontend-cp-customer-details': '19ada740-22d8-4ad4-b9cb-631d14993dfb',
    'frontend-cp-dashboard': '9ba57660-2f58-4211-876d-222a0ad419f3',
    'frontend-cp-deposits': 'bf7c1806-4278-47c3-ba6b-b8337ab4d207',
    'frontend-cp-documents': '23acfbcb-82d1-4050-9c57-43d7fedb392f',
    'frontend-cp-exemption-order': '0f80a8cf-10c6-4587-98fa-965a6b328767',
    'frontend-cp-identification': '7bdcf894-6fe1-4c8f-b29a-f599b8931ae1',
    'frontend-cp-investment-cockpits': 'c4fcface-63e7-4f48-8c68-af4c79204cf9',
    'frontend-cp-investment-orders': '2b404e9c-0e7a-4dc7-91db-c2927c58737c',
    'frontend-cp-login': '3e58dccd-7e1c-4976-a90f-fc41e2c17c13',
    'frontend-cp-my-deposits': '48ba0f6d-9da0-439e-a138-a93715f155d9',
    'frontend-cp-notifications': '84a6da5f-e81d-409b-8ab1-540426183cb1',
    'frontend-cp-payment-methods': 'd3ca2a4a-fbaa-47eb-9bbd-2dd72b39b710',
    'frontend-cp-postbox': 'd97dc31d-32ee-466a-8eec-903303e6b7f9',
    'frontend-cp-registration': '7988aca1-af1d-4a7c-87d9-730f9a0e3f51',
    'frontend-cp-user-account': 'ec792d03-d3a8-4197-b859-e46bb294c018',
    'frontend-customer-portal': '5d4b62a8-6aa3-421d-8c66-8220da7af3f5',
    'frontend-cap': 'e9e16e9b-3e6d-47cf-bb8f-99a77252ffb5',
    'frontend-cap-cpt-incident-management': 'e2dd3970-e8a7-458f-a1f7-4482bbe3d004',
    'frontend-cap-customer-communication': '34efc4fb-1998-4864-9eb0-fde6cc20bcf4',
    'frontend-cap-customer-direct-debit': 'dd3d7e2d-de15-4d9a-ae8c-093ac62d6b50',
    'frontend-cap-customer-simulation': 'a9a4f1f1-a930-4187-b9c0-49d2ce3793e0',
    'frontend-cap-customer-taxation': 'f301ec1b-4e61-4853-a7a1-79995e3ff6c4',
    'frontend-cap-customer-taxation-reconciliation': '933d3418-72ee-4c04-86d9-ed21d0a8c0c9',
    'frontend-cap-customers': '1a2d787b-e34f-4a13-baec-8381618ec9bc',
    'frontend-cap-deposit-taking-banks': '7ba51a05-9a26-4f55-8838-d95bddb003b0',
    'frontend-cap-deposits': '45a618a2-a905-41e5-889e-0944c554ca3c',
    'frontend-cap-documents': '16fc0c95-2eb2-4354-a6b8-46ffcce4b9d7',
    'frontend-cap-inm-incident-management': 'c0d20e35-a6b8-4653-aa7d-9c202a50e5e6',
    'frontend-cap-investments': '54a3988b-bc3a-43aa-b8d8-7cd177b6dd45',
    'frontend-cap-kyc': '25f8ee3c-c0ef-4aac-99dd-db6564e6df4a',
    'frontend-cap-postbox-broadcast': '0631cc31-7d1a-4f3a-b8cf-6cc114b9f412',
    'frontend-cap-revenue-reconciliation': '0ff86dc0-405d-4e4a-805c-347274399cf6',
    'frontend-cap-transactions': '18755ac9-d00e-4692-9e2d-26ca9afb3de1',
};
//# sourceMappingURL=dataDog-apps-ids.js.map